export default __webpack_public_path__ + "static/media/Banner 4_actualizado.5ebfc873.jpg";